enum AccountingTypesEnum {
    INVOICE = 1,
}

export default AccountingTypesEnum;
